 	// Reset Backup Local Storage
		$(document).ready(function() {
			localStorage.BackupTitleLine = "Empty";
			localStorage.BackupDestination = "Empty";
			localStorage.BackupOriginsLines = "Empty";
			localStorage.BackupShipInfoLines = "Empty";
			localStorage.BackupPlaqueLine1 = "Empty";
			localStorage.UserTitleLine = "Empty";
			localStorage.UserOriginsLines	= "Empty";
			localStorage.UserDestinyLines	= "Empty";
			localStorage.UserShipInfoLines	= "Empty";
			localStorage.UserPlaqueLine1	= "Empty";
			localStorage.UserPlaqueLine2	= "Empty";
			localStorage.UserPlaqueLine3	= "Empty";
			localStorage.UserPlaqueLine4	= "Empty";
			localStorage.UserPlaqueLine5	= "Empty";
			localStorage.UserPlaqueLine6	= "Empty";
			localStorage.UserTwoThree	= "Empty";
			localStorage.UserShipPicURL	= "Empty";
			localStorage.UsershipImageTransparentBackground = "Empty";



				$("#verticalMigrationsMenu li").each(function(){
				console.log("#verticalMigrationsMenu -----");


				if($(this).css("display") == "list-item"){
					$(this).addClass("hover");
					var selectNavItem = $(this).text();
					console.log("selectNavItem", selectNavItem);
					var range = $(this).parent().parent().parent().find('a').eq(0).text();  
					console.log("range", range);
					echoMigration(selectNavItem);
					return false;
				}
			})
		});
		 console.log("localStorage --------", localStorage);